/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SessionBridgeRouteImport } from './routes/session-bridge'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardUsageRouteImport } from './routes/_dashboard/usage'
import { Route as DashboardTeamRouteImport } from './routes/_dashboard/team'
import { Route as DashboardSuperadminRouteImport } from './routes/_dashboard/superadmin'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as DashboardNotificationsRouteImport } from './routes/_dashboard/notifications'
import { Route as DashboardBillingRouteImport } from './routes/_dashboard/billing'
import { Route as DashboardApiAccessRouteImport } from './routes/_dashboard/api-access'
import { Route as DashboardActivityRouteImport } from './routes/_dashboard/activity'
import { Route as DashboardAboutRouteImport } from './routes/_dashboard/about'
import { Route as OnboardingBrandRouteRouteImport } from './routes/onboarding/brand/route'
import { Route as OnboardingBrandNewRouteImport } from './routes/onboarding/brand/new'
import { Route as DashboardBrandPromptsRouteImport } from './routes/_dashboard/$brand/prompts'
import { Route as DashboardBrandPersonasRouteImport } from './routes/_dashboard/$brand/personas'
import { Route as DashboardBrandIntegrationsRouteImport } from './routes/_dashboard/$brand/integrations'
import { Route as DashboardBrandDashboardRouteImport } from './routes/_dashboard/$brand/dashboard'
import { Route as DashboardBrandCompetitorsRouteImport } from './routes/_dashboard/$brand/competitors'
import { Route as DashboardBrandBrandRouteImport } from './routes/_dashboard/$brand/brand'
import { Route as DashboardBrandAnalyticsRouteImport } from './routes/_dashboard/$brand/analytics'
import { Route as DashboardBrandSearchesIndexRouteImport } from './routes/_dashboard/$brand/searches/index'
import { Route as DashboardBrandReportsIndexRouteImport } from './routes/_dashboard/$brand/reports/index'
import { Route as OnboardingBrandBrandIdPromptsRouteImport } from './routes/onboarding/brand/$brandId/prompts'
import { Route as OnboardingBrandBrandIdProfileRouteImport } from './routes/onboarding/brand/$brandId/profile'
import { Route as OnboardingBrandBrandIdPersonaRouteImport } from './routes/onboarding/brand/$brandId/persona'
import { Route as OnboardingBrandBrandIdBasicRouteImport } from './routes/onboarding/brand/$brandId/basic'
import { Route as DashboardBrandReportsReportRouteImport } from './routes/_dashboard/$brand/reports/$report'
import { Route as DashboardBrandSearchesSearchIndexRouteImport } from './routes/_dashboard/$brand/searches/$search/index'
import { Route as DashboardBrandSearchesSearchResponsesRouteImport } from './routes/_dashboard/$brand/searches/$search/responses'

const SessionBridgeRoute = SessionBridgeRouteImport.update({
  id: '/session-bridge',
  path: '/session-bridge',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUsageRoute = DashboardUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTeamRoute = DashboardTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSuperadminRoute = DashboardSuperadminRouteImport.update({
  id: '/superadmin',
  path: '/superadmin',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardNotificationsRoute = DashboardNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBillingRoute = DashboardBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardApiAccessRoute = DashboardApiAccessRouteImport.update({
  id: '/api-access',
  path: '/api-access',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardActivityRoute = DashboardActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAboutRoute = DashboardAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const OnboardingBrandRouteRoute = OnboardingBrandRouteRouteImport.update({
  id: '/onboarding/brand',
  path: '/onboarding/brand',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingBrandNewRoute = OnboardingBrandNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OnboardingBrandRouteRoute,
} as any)
const DashboardBrandPromptsRoute = DashboardBrandPromptsRouteImport.update({
  id: '/$brand/prompts',
  path: '/$brand/prompts',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBrandPersonasRoute = DashboardBrandPersonasRouteImport.update({
  id: '/$brand/personas',
  path: '/$brand/personas',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBrandIntegrationsRoute =
  DashboardBrandIntegrationsRouteImport.update({
    id: '/$brand/integrations',
    path: '/$brand/integrations',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBrandDashboardRoute = DashboardBrandDashboardRouteImport.update({
  id: '/$brand/dashboard',
  path: '/$brand/dashboard',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBrandCompetitorsRoute =
  DashboardBrandCompetitorsRouteImport.update({
    id: '/$brand/competitors',
    path: '/$brand/competitors',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBrandBrandRoute = DashboardBrandBrandRouteImport.update({
  id: '/$brand/brand',
  path: '/$brand/brand',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBrandAnalyticsRoute = DashboardBrandAnalyticsRouteImport.update({
  id: '/$brand/analytics',
  path: '/$brand/analytics',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBrandSearchesIndexRoute =
  DashboardBrandSearchesIndexRouteImport.update({
    id: '/$brand/searches/',
    path: '/$brand/searches/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBrandReportsIndexRoute =
  DashboardBrandReportsIndexRouteImport.update({
    id: '/$brand/reports/',
    path: '/$brand/reports/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const OnboardingBrandBrandIdPromptsRoute =
  OnboardingBrandBrandIdPromptsRouteImport.update({
    id: '/$brandId/prompts',
    path: '/$brandId/prompts',
    getParentRoute: () => OnboardingBrandRouteRoute,
  } as any)
const OnboardingBrandBrandIdProfileRoute =
  OnboardingBrandBrandIdProfileRouteImport.update({
    id: '/$brandId/profile',
    path: '/$brandId/profile',
    getParentRoute: () => OnboardingBrandRouteRoute,
  } as any)
const OnboardingBrandBrandIdPersonaRoute =
  OnboardingBrandBrandIdPersonaRouteImport.update({
    id: '/$brandId/persona',
    path: '/$brandId/persona',
    getParentRoute: () => OnboardingBrandRouteRoute,
  } as any)
const OnboardingBrandBrandIdBasicRoute =
  OnboardingBrandBrandIdBasicRouteImport.update({
    id: '/$brandId/basic',
    path: '/$brandId/basic',
    getParentRoute: () => OnboardingBrandRouteRoute,
  } as any)
const DashboardBrandReportsReportRoute =
  DashboardBrandReportsReportRouteImport.update({
    id: '/$brand/reports/$report',
    path: '/$brand/reports/$report',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBrandSearchesSearchIndexRoute =
  DashboardBrandSearchesSearchIndexRouteImport.update({
    id: '/$brand/searches/$search/',
    path: '/$brand/searches/$search/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBrandSearchesSearchResponsesRoute =
  DashboardBrandSearchesSearchResponsesRouteImport.update({
    id: '/$brand/searches/$search/responses',
    path: '/$brand/searches/$search/responses',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/session-bridge': typeof SessionBridgeRoute
  '/onboarding/brand': typeof OnboardingBrandRouteRouteWithChildren
  '/about': typeof DashboardAboutRoute
  '/activity': typeof DashboardActivityRoute
  '/api-access': typeof DashboardApiAccessRoute
  '/billing': typeof DashboardBillingRoute
  '/notifications': typeof DashboardNotificationsRoute
  '/settings': typeof DashboardSettingsRoute
  '/superadmin': typeof DashboardSuperadminRoute
  '/team': typeof DashboardTeamRoute
  '/usage': typeof DashboardUsageRoute
  '/$brand/analytics': typeof DashboardBrandAnalyticsRoute
  '/$brand/brand': typeof DashboardBrandBrandRoute
  '/$brand/competitors': typeof DashboardBrandCompetitorsRoute
  '/$brand/dashboard': typeof DashboardBrandDashboardRoute
  '/$brand/integrations': typeof DashboardBrandIntegrationsRoute
  '/$brand/personas': typeof DashboardBrandPersonasRoute
  '/$brand/prompts': typeof DashboardBrandPromptsRoute
  '/onboarding/brand/new': typeof OnboardingBrandNewRoute
  '/$brand/reports/$report': typeof DashboardBrandReportsReportRoute
  '/onboarding/brand/$brandId/basic': typeof OnboardingBrandBrandIdBasicRoute
  '/onboarding/brand/$brandId/persona': typeof OnboardingBrandBrandIdPersonaRoute
  '/onboarding/brand/$brandId/profile': typeof OnboardingBrandBrandIdProfileRoute
  '/onboarding/brand/$brandId/prompts': typeof OnboardingBrandBrandIdPromptsRoute
  '/$brand/reports': typeof DashboardBrandReportsIndexRoute
  '/$brand/searches': typeof DashboardBrandSearchesIndexRoute
  '/$brand/searches/$search/responses': typeof DashboardBrandSearchesSearchResponsesRoute
  '/$brand/searches/$search': typeof DashboardBrandSearchesSearchIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/session-bridge': typeof SessionBridgeRoute
  '/onboarding/brand': typeof OnboardingBrandRouteRouteWithChildren
  '/about': typeof DashboardAboutRoute
  '/activity': typeof DashboardActivityRoute
  '/api-access': typeof DashboardApiAccessRoute
  '/billing': typeof DashboardBillingRoute
  '/notifications': typeof DashboardNotificationsRoute
  '/settings': typeof DashboardSettingsRoute
  '/superadmin': typeof DashboardSuperadminRoute
  '/team': typeof DashboardTeamRoute
  '/usage': typeof DashboardUsageRoute
  '/$brand/analytics': typeof DashboardBrandAnalyticsRoute
  '/$brand/brand': typeof DashboardBrandBrandRoute
  '/$brand/competitors': typeof DashboardBrandCompetitorsRoute
  '/$brand/dashboard': typeof DashboardBrandDashboardRoute
  '/$brand/integrations': typeof DashboardBrandIntegrationsRoute
  '/$brand/personas': typeof DashboardBrandPersonasRoute
  '/$brand/prompts': typeof DashboardBrandPromptsRoute
  '/onboarding/brand/new': typeof OnboardingBrandNewRoute
  '/$brand/reports/$report': typeof DashboardBrandReportsReportRoute
  '/onboarding/brand/$brandId/basic': typeof OnboardingBrandBrandIdBasicRoute
  '/onboarding/brand/$brandId/persona': typeof OnboardingBrandBrandIdPersonaRoute
  '/onboarding/brand/$brandId/profile': typeof OnboardingBrandBrandIdProfileRoute
  '/onboarding/brand/$brandId/prompts': typeof OnboardingBrandBrandIdPromptsRoute
  '/$brand/reports': typeof DashboardBrandReportsIndexRoute
  '/$brand/searches': typeof DashboardBrandSearchesIndexRoute
  '/$brand/searches/$search/responses': typeof DashboardBrandSearchesSearchResponsesRoute
  '/$brand/searches/$search': typeof DashboardBrandSearchesSearchIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/session-bridge': typeof SessionBridgeRoute
  '/onboarding/brand': typeof OnboardingBrandRouteRouteWithChildren
  '/_dashboard/about': typeof DashboardAboutRoute
  '/_dashboard/activity': typeof DashboardActivityRoute
  '/_dashboard/api-access': typeof DashboardApiAccessRoute
  '/_dashboard/billing': typeof DashboardBillingRoute
  '/_dashboard/notifications': typeof DashboardNotificationsRoute
  '/_dashboard/settings': typeof DashboardSettingsRoute
  '/_dashboard/superadmin': typeof DashboardSuperadminRoute
  '/_dashboard/team': typeof DashboardTeamRoute
  '/_dashboard/usage': typeof DashboardUsageRoute
  '/_dashboard/$brand/analytics': typeof DashboardBrandAnalyticsRoute
  '/_dashboard/$brand/brand': typeof DashboardBrandBrandRoute
  '/_dashboard/$brand/competitors': typeof DashboardBrandCompetitorsRoute
  '/_dashboard/$brand/dashboard': typeof DashboardBrandDashboardRoute
  '/_dashboard/$brand/integrations': typeof DashboardBrandIntegrationsRoute
  '/_dashboard/$brand/personas': typeof DashboardBrandPersonasRoute
  '/_dashboard/$brand/prompts': typeof DashboardBrandPromptsRoute
  '/onboarding/brand/new': typeof OnboardingBrandNewRoute
  '/_dashboard/$brand/reports/$report': typeof DashboardBrandReportsReportRoute
  '/onboarding/brand/$brandId/basic': typeof OnboardingBrandBrandIdBasicRoute
  '/onboarding/brand/$brandId/persona': typeof OnboardingBrandBrandIdPersonaRoute
  '/onboarding/brand/$brandId/profile': typeof OnboardingBrandBrandIdProfileRoute
  '/onboarding/brand/$brandId/prompts': typeof OnboardingBrandBrandIdPromptsRoute
  '/_dashboard/$brand/reports/': typeof DashboardBrandReportsIndexRoute
  '/_dashboard/$brand/searches/': typeof DashboardBrandSearchesIndexRoute
  '/_dashboard/$brand/searches/$search/responses': typeof DashboardBrandSearchesSearchResponsesRoute
  '/_dashboard/$brand/searches/$search/': typeof DashboardBrandSearchesSearchIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/session-bridge'
    | '/onboarding/brand'
    | '/about'
    | '/activity'
    | '/api-access'
    | '/billing'
    | '/notifications'
    | '/settings'
    | '/superadmin'
    | '/team'
    | '/usage'
    | '/$brand/analytics'
    | '/$brand/brand'
    | '/$brand/competitors'
    | '/$brand/dashboard'
    | '/$brand/integrations'
    | '/$brand/personas'
    | '/$brand/prompts'
    | '/onboarding/brand/new'
    | '/$brand/reports/$report'
    | '/onboarding/brand/$brandId/basic'
    | '/onboarding/brand/$brandId/persona'
    | '/onboarding/brand/$brandId/profile'
    | '/onboarding/brand/$brandId/prompts'
    | '/$brand/reports'
    | '/$brand/searches'
    | '/$brand/searches/$search/responses'
    | '/$brand/searches/$search'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/session-bridge'
    | '/onboarding/brand'
    | '/about'
    | '/activity'
    | '/api-access'
    | '/billing'
    | '/notifications'
    | '/settings'
    | '/superadmin'
    | '/team'
    | '/usage'
    | '/$brand/analytics'
    | '/$brand/brand'
    | '/$brand/competitors'
    | '/$brand/dashboard'
    | '/$brand/integrations'
    | '/$brand/personas'
    | '/$brand/prompts'
    | '/onboarding/brand/new'
    | '/$brand/reports/$report'
    | '/onboarding/brand/$brandId/basic'
    | '/onboarding/brand/$brandId/persona'
    | '/onboarding/brand/$brandId/profile'
    | '/onboarding/brand/$brandId/prompts'
    | '/$brand/reports'
    | '/$brand/searches'
    | '/$brand/searches/$search/responses'
    | '/$brand/searches/$search'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/auth'
    | '/session-bridge'
    | '/onboarding/brand'
    | '/_dashboard/about'
    | '/_dashboard/activity'
    | '/_dashboard/api-access'
    | '/_dashboard/billing'
    | '/_dashboard/notifications'
    | '/_dashboard/settings'
    | '/_dashboard/superadmin'
    | '/_dashboard/team'
    | '/_dashboard/usage'
    | '/_dashboard/$brand/analytics'
    | '/_dashboard/$brand/brand'
    | '/_dashboard/$brand/competitors'
    | '/_dashboard/$brand/dashboard'
    | '/_dashboard/$brand/integrations'
    | '/_dashboard/$brand/personas'
    | '/_dashboard/$brand/prompts'
    | '/onboarding/brand/new'
    | '/_dashboard/$brand/reports/$report'
    | '/onboarding/brand/$brandId/basic'
    | '/onboarding/brand/$brandId/persona'
    | '/onboarding/brand/$brandId/profile'
    | '/onboarding/brand/$brandId/prompts'
    | '/_dashboard/$brand/reports/'
    | '/_dashboard/$brand/searches/'
    | '/_dashboard/$brand/searches/$search/responses'
    | '/_dashboard/$brand/searches/$search/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
  SessionBridgeRoute: typeof SessionBridgeRoute
  OnboardingBrandRouteRoute: typeof OnboardingBrandRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/session-bridge': {
      id: '/session-bridge'
      path: '/session-bridge'
      fullPath: '/session-bridge'
      preLoaderRoute: typeof SessionBridgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/usage': {
      id: '/_dashboard/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof DashboardUsageRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/team': {
      id: '/_dashboard/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof DashboardTeamRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/superadmin': {
      id: '/_dashboard/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof DashboardSuperadminRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/notifications': {
      id: '/_dashboard/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof DashboardNotificationsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/billing': {
      id: '/_dashboard/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof DashboardBillingRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/api-access': {
      id: '/_dashboard/api-access'
      path: '/api-access'
      fullPath: '/api-access'
      preLoaderRoute: typeof DashboardApiAccessRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/activity': {
      id: '/_dashboard/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof DashboardActivityRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/about': {
      id: '/_dashboard/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof DashboardAboutRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/onboarding/brand': {
      id: '/onboarding/brand'
      path: '/onboarding/brand'
      fullPath: '/onboarding/brand'
      preLoaderRoute: typeof OnboardingBrandRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/brand/new': {
      id: '/onboarding/brand/new'
      path: '/new'
      fullPath: '/onboarding/brand/new'
      preLoaderRoute: typeof OnboardingBrandNewRouteImport
      parentRoute: typeof OnboardingBrandRouteRoute
    }
    '/_dashboard/$brand/prompts': {
      id: '/_dashboard/$brand/prompts'
      path: '/$brand/prompts'
      fullPath: '/$brand/prompts'
      preLoaderRoute: typeof DashboardBrandPromptsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/personas': {
      id: '/_dashboard/$brand/personas'
      path: '/$brand/personas'
      fullPath: '/$brand/personas'
      preLoaderRoute: typeof DashboardBrandPersonasRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/integrations': {
      id: '/_dashboard/$brand/integrations'
      path: '/$brand/integrations'
      fullPath: '/$brand/integrations'
      preLoaderRoute: typeof DashboardBrandIntegrationsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/dashboard': {
      id: '/_dashboard/$brand/dashboard'
      path: '/$brand/dashboard'
      fullPath: '/$brand/dashboard'
      preLoaderRoute: typeof DashboardBrandDashboardRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/competitors': {
      id: '/_dashboard/$brand/competitors'
      path: '/$brand/competitors'
      fullPath: '/$brand/competitors'
      preLoaderRoute: typeof DashboardBrandCompetitorsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/brand': {
      id: '/_dashboard/$brand/brand'
      path: '/$brand/brand'
      fullPath: '/$brand/brand'
      preLoaderRoute: typeof DashboardBrandBrandRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/analytics': {
      id: '/_dashboard/$brand/analytics'
      path: '/$brand/analytics'
      fullPath: '/$brand/analytics'
      preLoaderRoute: typeof DashboardBrandAnalyticsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/searches/': {
      id: '/_dashboard/$brand/searches/'
      path: '/$brand/searches'
      fullPath: '/$brand/searches'
      preLoaderRoute: typeof DashboardBrandSearchesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/reports/': {
      id: '/_dashboard/$brand/reports/'
      path: '/$brand/reports'
      fullPath: '/$brand/reports'
      preLoaderRoute: typeof DashboardBrandReportsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/onboarding/brand/$brandId/prompts': {
      id: '/onboarding/brand/$brandId/prompts'
      path: '/$brandId/prompts'
      fullPath: '/onboarding/brand/$brandId/prompts'
      preLoaderRoute: typeof OnboardingBrandBrandIdPromptsRouteImport
      parentRoute: typeof OnboardingBrandRouteRoute
    }
    '/onboarding/brand/$brandId/profile': {
      id: '/onboarding/brand/$brandId/profile'
      path: '/$brandId/profile'
      fullPath: '/onboarding/brand/$brandId/profile'
      preLoaderRoute: typeof OnboardingBrandBrandIdProfileRouteImport
      parentRoute: typeof OnboardingBrandRouteRoute
    }
    '/onboarding/brand/$brandId/persona': {
      id: '/onboarding/brand/$brandId/persona'
      path: '/$brandId/persona'
      fullPath: '/onboarding/brand/$brandId/persona'
      preLoaderRoute: typeof OnboardingBrandBrandIdPersonaRouteImport
      parentRoute: typeof OnboardingBrandRouteRoute
    }
    '/onboarding/brand/$brandId/basic': {
      id: '/onboarding/brand/$brandId/basic'
      path: '/$brandId/basic'
      fullPath: '/onboarding/brand/$brandId/basic'
      preLoaderRoute: typeof OnboardingBrandBrandIdBasicRouteImport
      parentRoute: typeof OnboardingBrandRouteRoute
    }
    '/_dashboard/$brand/reports/$report': {
      id: '/_dashboard/$brand/reports/$report'
      path: '/$brand/reports/$report'
      fullPath: '/$brand/reports/$report'
      preLoaderRoute: typeof DashboardBrandReportsReportRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/searches/$search/': {
      id: '/_dashboard/$brand/searches/$search/'
      path: '/$brand/searches/$search'
      fullPath: '/$brand/searches/$search'
      preLoaderRoute: typeof DashboardBrandSearchesSearchIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/$brand/searches/$search/responses': {
      id: '/_dashboard/$brand/searches/$search/responses'
      path: '/$brand/searches/$search/responses'
      fullPath: '/$brand/searches/$search/responses'
      preLoaderRoute: typeof DashboardBrandSearchesSearchResponsesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardRouteRouteChildren {
  DashboardAboutRoute: typeof DashboardAboutRoute
  DashboardActivityRoute: typeof DashboardActivityRoute
  DashboardApiAccessRoute: typeof DashboardApiAccessRoute
  DashboardBillingRoute: typeof DashboardBillingRoute
  DashboardNotificationsRoute: typeof DashboardNotificationsRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardSuperadminRoute: typeof DashboardSuperadminRoute
  DashboardTeamRoute: typeof DashboardTeamRoute
  DashboardUsageRoute: typeof DashboardUsageRoute
  DashboardBrandAnalyticsRoute: typeof DashboardBrandAnalyticsRoute
  DashboardBrandBrandRoute: typeof DashboardBrandBrandRoute
  DashboardBrandCompetitorsRoute: typeof DashboardBrandCompetitorsRoute
  DashboardBrandDashboardRoute: typeof DashboardBrandDashboardRoute
  DashboardBrandIntegrationsRoute: typeof DashboardBrandIntegrationsRoute
  DashboardBrandPersonasRoute: typeof DashboardBrandPersonasRoute
  DashboardBrandPromptsRoute: typeof DashboardBrandPromptsRoute
  DashboardBrandReportsReportRoute: typeof DashboardBrandReportsReportRoute
  DashboardBrandReportsIndexRoute: typeof DashboardBrandReportsIndexRoute
  DashboardBrandSearchesIndexRoute: typeof DashboardBrandSearchesIndexRoute
  DashboardBrandSearchesSearchResponsesRoute: typeof DashboardBrandSearchesSearchResponsesRoute
  DashboardBrandSearchesSearchIndexRoute: typeof DashboardBrandSearchesSearchIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAboutRoute: DashboardAboutRoute,
  DashboardActivityRoute: DashboardActivityRoute,
  DashboardApiAccessRoute: DashboardApiAccessRoute,
  DashboardBillingRoute: DashboardBillingRoute,
  DashboardNotificationsRoute: DashboardNotificationsRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardSuperadminRoute: DashboardSuperadminRoute,
  DashboardTeamRoute: DashboardTeamRoute,
  DashboardUsageRoute: DashboardUsageRoute,
  DashboardBrandAnalyticsRoute: DashboardBrandAnalyticsRoute,
  DashboardBrandBrandRoute: DashboardBrandBrandRoute,
  DashboardBrandCompetitorsRoute: DashboardBrandCompetitorsRoute,
  DashboardBrandDashboardRoute: DashboardBrandDashboardRoute,
  DashboardBrandIntegrationsRoute: DashboardBrandIntegrationsRoute,
  DashboardBrandPersonasRoute: DashboardBrandPersonasRoute,
  DashboardBrandPromptsRoute: DashboardBrandPromptsRoute,
  DashboardBrandReportsReportRoute: DashboardBrandReportsReportRoute,
  DashboardBrandReportsIndexRoute: DashboardBrandReportsIndexRoute,
  DashboardBrandSearchesIndexRoute: DashboardBrandSearchesIndexRoute,
  DashboardBrandSearchesSearchResponsesRoute:
    DashboardBrandSearchesSearchResponsesRoute,
  DashboardBrandSearchesSearchIndexRoute:
    DashboardBrandSearchesSearchIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface OnboardingBrandRouteRouteChildren {
  OnboardingBrandNewRoute: typeof OnboardingBrandNewRoute
  OnboardingBrandBrandIdBasicRoute: typeof OnboardingBrandBrandIdBasicRoute
  OnboardingBrandBrandIdPersonaRoute: typeof OnboardingBrandBrandIdPersonaRoute
  OnboardingBrandBrandIdProfileRoute: typeof OnboardingBrandBrandIdProfileRoute
  OnboardingBrandBrandIdPromptsRoute: typeof OnboardingBrandBrandIdPromptsRoute
}

const OnboardingBrandRouteRouteChildren: OnboardingBrandRouteRouteChildren = {
  OnboardingBrandNewRoute: OnboardingBrandNewRoute,
  OnboardingBrandBrandIdBasicRoute: OnboardingBrandBrandIdBasicRoute,
  OnboardingBrandBrandIdPersonaRoute: OnboardingBrandBrandIdPersonaRoute,
  OnboardingBrandBrandIdProfileRoute: OnboardingBrandBrandIdProfileRoute,
  OnboardingBrandBrandIdPromptsRoute: OnboardingBrandBrandIdPromptsRoute,
}

const OnboardingBrandRouteRouteWithChildren =
  OnboardingBrandRouteRoute._addFileChildren(OnboardingBrandRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  AuthRoute: AuthRoute,
  SessionBridgeRoute: SessionBridgeRoute,
  OnboardingBrandRouteRoute: OnboardingBrandRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
